import { render, staticRenderFns } from "./seo.vue?vue&type=template&id=32e9c1ee&scoped=true&"
import script from "./seo.vue?vue&type=script&lang=ts&"
export * from "./seo.vue?vue&type=script&lang=ts&"
import style0 from "./seo.vue?vue&type=style&index=0&id=32e9c1ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e9c1ee",
  null
  
)

export default component.exports